<div [class]="organisation$ | async">
  <router-outlet></router-outlet>
</div>
